export const TEST = 'test'
export const SUCCESS = 'success'
